// facebookConfig.js

const facebookConfig = {
  // App ID từ Facebook Developer Console
  appId: process.env.REACT_APP_FACEBOOK_APP_ID,

  // Cookie để server có thể truy cập session
  cookie: true,

  // Parse social plugins trên trang (set false nếu không dùng Like/Share/Comment buttons)
  xfbml: false,

  // Phiên bản Graph API
  version: 'v25.0',

  // Ngôn ngữ SDK
  language: 'en_US', // vi_VN locale có lỗi ModuleError nội bộ

  // URL SDK
  sdkUrl: 'https://connect.facebook.net/en_US/sdk.js',

  // Scope mặc định khi đăng nhập
  defaultScope: 'public_profile,email',

  // Fields mặc định khi lấy thông tin user
  defaultFields: 'id,name,email,picture',

  // Các scope có sẵn (để tham khảo)
  availableScopes: {
    basic: 'public_profile,email',
    extended: 'public_profile,email,user_birthday,user_location',
    friends: 'user_friends',
    pages: 'pages_show_list,pages_manage_posts',
  },

  // Các fields có sẵn (để tham khảo)
  availableFields: {
    basic: 'id,name,email,picture',
    extended: 'id,name,email,picture,birthday,gender,location',
    full: 'id,name,first_name,last_name,email,picture{url,width,height},cover,birthday,gender,hometown,location',
  },
};

export default facebookConfig;

// ======================================
// CÁCH SỬ DỤNG:
// ======================================

// Trong facebookService.js:
/*
import facebookConfig from './facebookConfig';

const FacebookService = {
  config: {
    appId: facebookConfig.appId,
    cookie: facebookConfig.cookie,
    xfbml: facebookConfig.xfbml,
    version: facebookConfig.version
  },
  
  init() {
    return new Promise((resolve) => {
      window.fbAsyncInit = function() {
        window.FB.init(FacebookService.config);
        resolve();
      };
      
      (function(d, s, id) {
        let js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = facebookConfig.sdkUrl;
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    });
  },
  
  login(scope = facebookConfig.defaultScope) {
    return new Promise((resolve) => {
      window.FB.login((response) => {
        resolve(response);
      }, { scope });
    });
  },
  
  getUserInfo(fields = facebookConfig.defaultFields) {
    return new Promise((resolve, reject) => {
      window.FB.api('/me', { fields }, (response) => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(response);
        }
      });
    });
  }
};

export default FacebookService;
*/
